import SocialMediaIconsReact from './social-media-icons-react';

export {
    SocialMediaIconsReact
};

